import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RegisterGAService } from '@uc/web/analytics';
import {
	PrimaryBlueBtnComponent,
	DownloadAppBtnComponent,
	SecondaryBlueBtnComponent,
} from '@uc/web/shared/buttons';

@Component({
	selector: 'uc-cta-clearing-non-featured',
	templateUrl: './cta-clearing-non-featured.component.html',
	imports: [
		PrimaryBlueBtnComponent,
		DownloadAppBtnComponent,
		SecondaryBlueBtnComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtaClearingNonFeaturedComponent {
	slug = input.required<string>();

	private readonly _componentName = 'Profile Header';

	constructor(private _registerGASrv: RegisterGAService) {}

	onCreateAccountClick() {
		this._registerGASrv.registerClick(this._componentName);
	}
}
